import { Form, Formik } from 'formik';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import Button from '../../../components/buttons/Button';
import { sendIcon } from '../../../config/variables';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import useFormsIntegrationHelpers from '../../../hooks/useFormsIntegrationHelpers';

export default function StepAddComment({ fieldId }: { fieldId: number | undefined }) {
  const { t } = useTranslation();
  const { id } = useParams();

  const {handleSubmit, submitLoading} = useFormsIntegrationHelpers({
    addApi: `/admin/orders/${id}/steps/submit`,
    invalidateQueryKey: ['orders'],
    customMessage: `${t('addedComment')} ${t('successfully')}`,
  })

  const validationSchema = Yup.object({
    comment: Yup.string().min(3, t('comment_too_short')).max(100, t('comment_too_long'))
  });

  return (
    <Formik
      initialValues={{ comment: '' }}
      onSubmit={(values, { setErrors, resetForm }) => {
        const newValues = { [`comments[${fieldId}]`]: values?.comment, status: 'rejected' }
        handleSubmit(newValues, setErrors, resetForm)
      }}
      enableReinitialize
      validateOnMount
      validationSchema={validationSchema}
    >
      {(formik) => (
        <>
          <Form>
            <div className="add-comment">
              <FieldWrapper
                inputName={'comment'}
                inputPlaceholder={t('addComment')}
                inputError={formik.errors.comment as string}
                inputTouched={formik.touched.comment as boolean}
                input
                customPadding
              />
              <Button
                text={sendIcon}
                customClass="icon-only"
                disabled={formik.values.comment.length > 2 ? false : true}
                loading={submitLoading}
                commentBtn
                onClick={() => {
                  formik.submitForm();
                }}
                type="submit"
              />
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
